const {
  formatBookingDateForDisplay,
  getMinimumBookingDate,
  isCopenhagenDateAvailable,
  normalizeBookingCutoff,
  normalizeBookingDate
} = require('@/utils/bookingDate')

export default {
  methods: {
    isTodayBookingAllowedForDateValidation () {
      if (this.getUrlPrices && this.getUrlPrices.todayBookingAllowed) return true

      try {
        return window.sessionStorage.getItem('todayBookingAllowed') === '1'
      } catch (e) {
        return false
      }
    },
    getCurrentMinimumBookingDate () {
      const urlPrices = this.getUrlPrices || {}

      return getMinimumBookingDate({
        lastTime: normalizeBookingCutoff(urlPrices.lastTime),
        todayBookingAllowed: this.isTodayBookingAllowedForDateValidation(),
        highSeasonStart: this.$func.getHighSeasonStart(),
        highSeasonEnd: this.$func.getHighSeasonEnd()
      })
    },
    getBookingDateValidationError (date, label) {
      const minimumDate = this.getCurrentMinimumBookingDate()

      const normalizedDate = normalizeBookingDate(date)
      if (!normalizedDate) {
        return `Please select a valid ${label.toLowerCase()}.`
      }

      if (normalizedDate < minimumDate) {
        return `${label} is no longer available. Please choose ${formatBookingDateForDisplay(minimumDate)} or later.`
      }

      return ''
    },
    getBookingAvailabilityValidationError () {
      const bookingContext = this.getBookingContext || {}
      const availableDates = Array.isArray(bookingContext.availableDates)
        ? bookingContext.availableDates
        : []

      if (!bookingContext.availabilityRestricted) return ''
      if (availableDates.length && isCopenhagenDateAvailable(availableDates)) return ''

      return 'This booking link is not available today. Please contact us or start a new booking.'
    },
    getActiveBookingDateValidationError () {
      const storageInfo = this.getStorageInfo || {}
      const isStorageBooking = (this.getOrderInfo && this.getOrderInfo.from === 'storage') ||
        Number(storageInfo.numberOfBags) > 0 ||
        Number(storageInfo.numberOfHeavyBags) > 0

      const dateValidationError = isStorageBooking
        ? this.getBookingDateValidationError(storageInfo.storageDateFrom, 'Storage start date')
        : this.getBookingDateValidationError(this.getOrderInfo && this.getOrderInfo.arrivalDate, 'Arrival / transfer date')

      return dateValidationError ||
        (isStorageBooking ? '' : this.getBookingAvailabilityValidationError())
    },
    getBookingEligibilityPayload () {
      const storageInfo = this.getStorageInfo || {}
      const isStorageBooking = (this.getOrderInfo && this.getOrderInfo.from === 'storage') ||
        Number(storageInfo.numberOfBags) > 0 ||
        Number(storageInfo.numberOfHeavyBags) > 0
      const bookingContext = this.getBookingContext || {}

      return {
        type: isStorageBooking ? 'storage' : 'transport',
        date: normalizeBookingDate(isStorageBooking
          ? storageInfo.storageDateFrom
          : (this.getOrderInfo && this.getOrderInfo.arrivalDate)),
        lastTime: normalizeBookingCutoff(this.getUrlPrices && this.getUrlPrices.lastTime),
        todayBookingAllowed: this.isTodayBookingAllowedForDateValidation(),
        availabilityRestricted: !isStorageBooking &&
          Boolean(bookingContext.availabilityRestricted),
        availableDates: !isStorageBooking && Array.isArray(bookingContext.availableDates)
          ? bookingContext.availableDates
          : []
      }
    }
  }
}
